<template>
    <div class="rechargerecordNew">
        <div class="section">
            <div class="search">
                <div>
                    <!-- 充值状态 -->
                    <span class="search-label">{{ $t('recharge.Recharge_status') }}</span>
                    <el-select v-model="searchRecharge.status" @change="getData(true)"
                        :placeholder="this.$t('header.pleaseSelect')" size="small" popper-class="select-search-recharge"
                        class="selectClearNew" clearable>
                        <el-option v-for="(val, key) in rechargeStatus" :key="key" :label="val.label" :value="key"
                            style="display:flex;align-items:center;">
                            <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${val.class}`"></i>
                            <span class="select-label">{{ val.label }}</span>
                        </el-option>
                    </el-select>
                    <el-date-picker :editable='false' @change="getData(true)" clearable v-model="datevalue"
                        type="daterange" align="left" unlink-panels ref="datePickerRange"
                        :range-separator="$t('report.to')"
                        :default-value="new Date().setMonth(new Date().getMonth() - 1)"
                        :picker-options="pickerrangeOptions" :start-placeholder="$t('report.start_date')"
                        :end-placeholder="$t('report.End_date')" popper-class="select-date1">
                    </el-date-picker>
                </div>
                <!-- 搜索 -->
                <el-button class="button button-solid" @click.stop="showSearchBtn">
                    <i class="el-icon-search"></i>
                </el-button>
                <div class="search-alert" v-show="showSearch">
                    <div class="searchDiv">
                        <el-input class="searchAll" ref="iptFocus" v-model.trim="searchRecharge.pn"
                            @keyup.enter.native="getData(true)" :placeholder="$t('datalogger.Datalogger_PN')" clearable>
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <span class="search-device" @click="getData(true)">{{ $t('recharge.Search') }}</span>
                        <span class="search-hide" @click="closeSearch">{{ $t('datalogger.cancel') }}</span>
                    </div>
                </div>
            </div>
            <!-- 表格 -->
            <el-table class="tablemain tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading"
                :data="rechargeList" stripe border height="100%"
                :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
                :empty-text="$t('account.nodata')">
                <el-table-column prop="orderno" :label="$t('recharge.Order_Number')"
                    :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="pn" :label="$t('recharge.Datalogger_PN')" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column :label="$t('device.device')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span class="viewDetails" @click="goDetails(scope.row.pn)">{{ $t('collectionFrequencyUP.View_Details') }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('collectionFrequencyUP.Type')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rechargeType==2">{{$t('collectionFrequencyUP.collect_fast1')}}({{ scope.row.parmerNumber }})</span>
                        <span v-else>{{$t('collectionFrequencyUP.collect_fast')}}({{ scope.row.parmerNumber }})</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('collectionFrequencyUP.acquisition_frequency')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rechargeType==2">{{ scope.row.frequency }}s/{{$t('collectionFrequencyUP.Once')}}</span>
                        <span v-else>{{ scope.row.frequency }}s/{{$t('collectionFrequencyUP.Once')}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('recharge.Recharge_money')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.channel==5? '$' : '￥'}}{{ scope.row.amount }}</span>
                        <img v-if="scope.row.orderType==1" :title="$t('collectionFrequencyUP.upPrice')" src="@/assets/img/recharge/priceUp.png" style="width: 10px;position: absolute;" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :show-overflow-tooltip="true" :label="$t('recharge.Time')">
                </el-table-column>
                <el-table-column prop="status" :label="$t('recharge.rechargeStatus')"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status !== undefined"
                            :class="`color-${rechargeStatus[scope.row.status].class}`">{{
                                rechargeStatus[scope.row.status] ?
                                    rechargeStatus[scope.row.status].label : '' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column :label="$t('recharge.Operation')" fixed="right" width="100"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == '0'" type="text" class="operation"
                            :title="$t('recharge.Recharge')" @click="openRecharge([scope.row])">
                            <i class="ico ico-recharge"></i>
                        </el-button>
                        <span v-else>/</span>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页 -->
            <div class="tablebottom">
                <!-- 批量占位 -->
                <span class="" style="margin-left:16px;"></span>
                <el-pagination class="pagination" popper-class="select-page" background @size-change="getData(true)"
                    @current-change="() => getData()" :current-page.sync="pagination.currentPage"
                    :page-sizes="[10, 15, 20, 30]" :page-size.sync="pagination.pagesize"
                    layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total">
                    <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
                </el-pagination>
            </div>
        </div>
        <recharge-dialog :title="$t('collectionFrequencyUP.device_Info')" :visible.sync="deviceListDialog" :class="{
            showDialog: deviceListDialog,
            hideDialog: !deviceListDialog,
        }" width="600px" noFooter>
            <div slot="content">
                <el-table class="tablemain tableloding" :data="deviceList" stripe border
                    :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
                    :empty-text="$t('account.nodata')">
                    <el-table-column :label="$t('settingalarm.list')" fixed type="index" width="70">
                    </el-table-column>
                    <el-table-column :label="$t('device.deviceName')" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{ scope.row.devalias ? scope.row.devalias : scope.row.sn }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </recharge-dialog>

    </div>
</template>
<script>
import rechargeDialog from "@/components/dialognew";
export default {
    components: {
        rechargeDialog,
    },
    data() {
        return {
            deviceListDialog: false,
            deviceList: [],
            datevalue: "",
            pickerrangeOptions: {
                disabledDate: time => {
                    return time.getTime() > Date.now() - 8.64e6
                },
            },
            searchRecharge: {
                pn: '',
                status: '',
            },
            isLoading: false,
            pagination: {
                currentPage: 1,
                pagesize: 15,
                total: 0
            },
            rechargeList: [],
            // 订单状态列表
            rechargeStatus: {
                // 未付款
                1: {
                    class: "pending",
                    // class: "no",
                    label: this.$t('rosRecharge.pendingPayment')
                },
                // 成功
                2: {
                    class: "normal",
                    label: this.$t('rosRecharge.paymentSuccess')
                },
                // 失败
                3: {
                    class: "fault",
                    label: this.$t('rosRecharge.paymentFailed')
                },
                4: {
                    class: "standby",
                    label: this.$t('rosRecharge.orderClosed')
                },
                5: {
                    class: "cancel",
                    label: this.$t('rosRecharge.serviceTerminated')
                }
            },
            showSearch: false, // 搜索弹出
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        //获取充值记录
        getData(reset) {
            if (reset) this.pagination.currentPage = 1;
            let param = {
                current: this.pagination.currentPage ,
                size: this.pagination.pagesize,
                systemType: 1,
                // timezone: -(new Date().getTimezoneOffset() / 60),
                createTimeStart: this.datevalue ? this.$filter.formatDate(this.datevalue[0], "yyyy-MM-dd") : "",
                createTimeEnd: this.datevalue ? this.$filter.formatDate(this.datevalue[1], "yyyy-MM-dd") : "",
                ...this.searchRecharge
            };
            this.isLoading = true;
            this.$request
                .postDEVMicroservices("/ros/api/rechargeOrder/pub/getRechargeOrderPage", param)
                .then(res => {
                    if (res.code == 0) {
                        this.rechargeList = res.data.records;
                        this.pagination.total = res.data.total;
                    } else {
                        this.rechargeList = [];
                        this.pagination.total = 0;
                    }
                    this.isLoading = false;
                });
        },
        // openRecharge(){

        // },
        goDetails(pn) {
            this.deviceListDialog = true;
            this.$request
                .getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", {
                    pn: pn,
                    devtype: 2304,
                    page: 1,
                    pageSize: 50,
                })
                .then(res => {
                    if (res.code == 0) {
                        this.deviceList = this.Fnreturndev(res);
                    } else {
                        this.deviceList = []
                    }
                });
        },
        // 关闭搜索框
        closeSearch() {
            this.showSearch = false;
            this.searchRecharge.pn = '';
            this.searchRecharge.status = '';
            this.datevalue = ""
            this.getData();
        },
        showSearchBtn() {
            this.searchRecharge.pn = '';
            this.searchRecharge.status = '';
            this.datevalue = ""
            this.showSearch = true;
            this.$nextTick(() => {
                this.$refs.iptFocus.focus();
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.rechargerecordNew {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 20px;
    overflow: auto;

    .section {
        display: flex;
        flex: 1;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        overflow: hidden;

        /deep/.el-icon-loading {
            font-size: 28px;
        }

        .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);

            .search-label {
                display: inline-block;
                color: #ffffff;
                font-weight: bold;
                line-height: 48px;
                font-size: 14px;
                padding-left: 16px;
            }

            /deep/.el-select {
                width: 110px;
                border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
                background: @primaryColorTransparency30;
            }

            /deep/.el-input {
                width: 100%;
                text-align: center;
            }

            /deep/.el-input__inner {
                background: transparent;
                border: none;
                height: 48px;
                line-height: 48px;
                color: #ffffff;
                padding: 0 16px;
            }

            /deep/.el-input__suffix {
                right: 0px;
            }

            .button {
                height: 48px;
                line-height: 48px;
                padding: 0 25px;
                margin-top: 0px;
                color: @primaryTextColor;
                background: transparent;
                border: none;
            }

            .search-alert {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 48px;
                z-index: 1;
                background: rgb(34, 45, 53);
                display: flex;
                align-items: center;
                justify-content: space-between;

                .searchDiv {
                    position: absolute;
                    top: 0;
                    // left: 0;
                    right: 0;
                    width: 400px;
                    height: 48px;
                    z-index: 2;
                    background: rgb(34, 45, 53);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .searchAll {

                    // display: flex;
                    // align-items: center;
                    // justify-content: flex-end;
                    /deep/.el-input__inner {
                        width: 220px;
                        padding-left: 10px;
                    }
                }

                .search-device {
                    display: inline-block;
                    line-height: 48px;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #202D35;
                    color: #33FFB6;
                    cursor: pointer;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }

                .search-hide {
                    display: inline-block;
                    // position: absolute;
                    // right: -58px;
                    line-height: 48px;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #202D35;
                    color: #7B8395;
                    border-left: 1px solid #7B8395;
                    cursor: pointer;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }

                /deep/.el-input {
                    flex: 1;
                }

                /deep/.el-input .el-input__clear {
                    width: 48px;
                    color: #7B8395;
                }

                /deep/.el-input .el-input__clear:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                }

                /deep/.el-input .el-input__inner,
                /deep/.el-input .el-input__inner:hover {
                    height: 48px;
                    border-radius: 0px;
                    border: none;
                    background: #202D35;
                    color: #ffffff;
                    padding-left: 40px;
                }

                /deep/.el-input__prefix {
                    left: 0px;
                }

                /deep/.el-input__icon {
                    width: 40px;
                }

                /deep/.el-input__suffix {
                    right: 0px;
                }

                /deep/.el-input__suffix:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                }

                /deep/.el-icon-circle-close:before {
                    content: 'X'
                }

                /deep/.el-input:not(:last-child) {
                    margin-right: 0px;
                }
            }
        }

        .tableloding {

            // 加载数据时遮罩
            /deep/.el-loading-mask {
                background-color: rgb(34, 45, 53, .5);
            }

            /deep/.el-loading-spinner i {
                color: @primaryTextColor;
            }
        }

        .tablebottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
                line-height: 48px;
                height: 48px;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 16px;

                /deep/.el-pager li {
                    vertical-align: middle;
                }

                /deep/.el-select .el-input {
                    width: 90px;
                    margin: 0px;
                }

                /deep/.el-input .el-input__inner {
                    background-color: #202D35;
                    color: #ffffff;
                }

                /deep/.el-input__suffix {
                    right: 10px;
                }

                /deep/.el-pagination__sizes {
                    margin: 0px;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pagination__total {
                    color: #fff;
                    padding-left: 15px;
                    border-left: 1px solid #7B8395;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pager li:not(.disabled).active {
                    // background: #15C491;
                    // color: #ffffff;
                    background-color: #2B3842;
                    color: #15C491;
                }

                // li:not(.disabled):not(.active):hover
                /deep/.el-pager li:not(.disabled):hover {
                    background-color: @primaryColorTransparency30;
                    color: rgba(255, 255, 255, 1);
                }

                /deep/.el-pager li {
                    background-color: #2B3842;
                    color: #7B8395;
                }

                // 页条数下拉
                /deep/.el-select .el-input .el-input__inner {
                    border: none;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 0px;
                }

                /deep/.el-select .el-input .el-input__inner:hover {
                    background: @primaryColorTransparency30;
                }

                // 跳页
                /deep/.el-pagination__jump {
                    color: #ffffff;
                }

                /deep/.el-pagination__editor {
                    padding: 0px 6px;
                }

                /deep/.el-pagination__editor.el-input .el-input__inner {
                    border: 1px solid #7B8395;
                }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
                background-color: #2B3842;
                color: #7B8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
                background-color: #2B3842;
                color: #7B8395;
            }
        }
    }

    .tablemain {
        border: none;
        background-color: rgb(34, 45, 53);

        .operation i {
            color: @primaryTextColor;
        }

        /deep/.el-table--border::after,
        /deep/.el-table--group::after {
            width: 0px;
        }

        /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
            width: 16px;
            height: 16px;
            background: transparent;
            border: 1px solid rgb(180, 184, 193);
            border-radius: 0px;
        }

        /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
            top: 2px;
            left: 5px;
        }

        /deep/.el-table__header th {
            height: 48px;
        }

        /deep/.el-table__header th.is-leaf {
            border-color: rgba(198, 209, 221, 0.5);
            border-bottom: none;
        }

        /deep/.el-table__header th>.cell {
            font-weight: normal;
            font-size: 12px;
        }

        /deep/.el-table__body tr,
        /deep/.el-table__body td {
            background-color: rgb(34, 45, 53);
            color: #ffffff;
            border-color: rgba(198, 209, 221, 0.5);
        }

        /deep/.el-table__body td.el-table-column--selection {
            background-color: rgb(65, 80, 90);
            color: #ffffff;
        }

        /deep/.el-table__body .cell.el-tooltip {
            font-size: 14px;
        }

        /deep/.el-table__fixed-right::before,
        /deep/.el-table__fixed::before {
            display: none;
        }

        ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: #222d35;
        }

        // 关于头部右侧空白
        /deep/.el-table__fixed-right-patch {
            background-color: rgb(65, 80, 90);
            border-bottom: none;
        }

        /deep/th.gutter {
            background-color: rgb(65, 80, 90);
        }
    }

    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        background-color: #222d35;
    }

    /deep/.el-range__icon {
        margin-left: 25px;
    }

    /deep/.el-date-editor--daterange {
        color: #fff;
        background-color: #2b3842;
    }

    /deep/.el-range-input {
        color: #fff;
        background-color: #222d35;
        width: 160px;
    }

    /deep/.el-range-separator {
        color: #fff;
        width: 18%;
        line-height: 48px;
    }

    /deep/.el-icon-date:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        left: 10px;
        height: 24px;
        width: 24px;
        background: url(../../../assets/img/general/Icon_Calendar.png) no-repeat;
        background-size: 100%;
        background-position: center;
    }
}

.ico-recharge {
    background: url(../../../assets/img/general/Icon_Recharge.png);
}

.ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
}

.stepQrCode {
    display: flex;
    flex-direction: column;
    align-items: center;

    .price {
        .sc(26px, rgba(51, 255, 182, 1));
        line-height: 1.6;
    }

    .qr {
        width: 180px;
        height: 180px;
        margin: 10px 0 15px;
    }

    .info {
        .sc(16px, rgba(51, 255, 182, 1));
        line-height: 1.4;
    }
}

.rechargeSucResult {
    display: flex;
    flex-direction: column;
    align-items: center;

    .item {
        margin-top: 10px;
    }

    .rechargeResultButton {
        text-align: center;
        margin-top: 20px;
    }
}

.viewDetails {
    color: @primaryTextColor;
    cursor: pointer;
}

// 订单状态
.color-ok {
    color: rgb(73, 222, 255);
}

.color-no {
    color: rgb(123, 131, 149);
}
</style>
<style lang="less">
.select-date1.el-picker-panel {
    background-color: #222D35;
    border: none;
    padding-top: 10px;

    .el-picker-panel__body-wrapper {
        .el-picker-panel__body {
            border: #222D35;
        }

        .el-picker-panel__sidebar {
            width: 100%;
            position: relative;
            padding: 0px;
            background: transparent;
            color: #ffffff;
            border: none;

            .el-picker-panel__shortcut,
            .el-picker-panel__shortcut:hover {
                padding-left: 0px;
                padding-bottom: 20px;
                color: @primaryTextColor;
                text-align: center;
            }
        }
    }

    .el-date-range-picker__header {
        color: #fff;
    }

    .in-range {
        background-color: #222D35;
    }

    .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
    }

    .el-date-table td.today span {
        color: @primaryTextColor;
        font-weight: 700;
    }

    .el-date-table td.in-range div {
        background-color: rgba(48, 208, 150, 0.7);
    }

    .el-picker-panel__icon-btn {
        color: rgba(48, 208, 150);
        font-size: 14px;
        font-weight: bold;
    }


    .el-date-table td.end-date span,
    .el-date-table td.start-date span {
        color: #fff;
        background-color: @primaryTextColor;
        border: @primaryTextColor;
    }

    .el-date-table td.in-range {
        background-color: #222D35;
    }

    .el-date-table td:hover {
        color: rgba(48, 208, 150);
    }

    .el-date-table td.next-month,
    .el-date-table td.prev-month {
        color: #606266;
    }

    .el-date-table td {
        color: #fff
    }

    .el-date-table td.disabled div {
        background-color: #222D35 !important;
        color: #606266 !important;
    }
}
</style>